<div class="collections-page-container container" fxFlexFill fxLayout="column" fxLayoutAlign="start center">
  <div class="page-container container" fxLayout="column" fxLayoutGap="15px">
    <mtn-breadcrumbs></mtn-breadcrumbs>
    <router-outlet></router-outlet>
  </div>
</div>
